const c = ["default", "creditCard", "monthYear", "cpf", "cnpj", "phone", "cellPhone", "cep", "currency", "cvv", "numeric"], o = {
  cpf: {
    pattern: /(\d{3})(\d{0,3})(\d{0,3})(\d{0,2})/,
    format: "$1.$2.$3-$4",
    maxLength: 11
  },
  cnpj: {
    pattern: /(\d{2})(\d{0,3})(\d{0,3})(\d{0,4})(\d{0,2})/,
    format: "$1.$2.$3/$4-$5",
    maxLength: 14
  },
  phone: {
    pattern: /(\d{2})(\d{0,4})(\d{0,4})/,
    format: "($1) $2-$3",
    maxLength: 10
  },
  cellPhone: {
    pattern: /(\d{2})(\d{0,5})(\d{0,4})/,
    format: "($1) $2-$3",
    maxLength: 11
  },
  cep: {
    pattern: /(\d{5})(\d{0,3})/,
    format: "$1-$2",
    maxLength: 8
  },
  cvv: {
    pattern: /(\d{3,4})/,
    format: "$1",
    maxLength: 4
  },
  monthYear: {
    pattern: /(\d{2})(\d{0,2})/,
    format: "$1/$2",
    maxLength: 4
  },
  creditCard: {
    pattern: /(\d{4})(\d{0,4})(\d{0,4})(\d{0,4})/,
    format: "$1 $2 $3 $4",
    maxLength: 16
  },
  currency: {
    pattern: /(\d)/,
    format: "$1",
    maxLength: 100
  },
  numeric: {
    pattern: /(\d)/,
    format: "$1",
    maxLength: 1 / 0
  }
};
function $({
  value: t,
  maskType: r
}) {
  if (r == c[0])
    return t;
  if (!t && r == c[8])
    return "R$ 0,00";
  if (!t)
    return "";
  t = t.replace(/\D/g, "");
  const {
    pattern: n,
    format: a,
    maxLength: m
  } = o[r];
  t = t.slice(0, m);
  let e = t.replace(n, a);
  return e = e.replace(/(\.|\/|\-|\(|\)|\s|\$|\,)+$/, ""), r == c[8] && (e = d(e)), e;
}
function d(t) {
  if (!t)
    return "R$ 0,00";
  const r = Number(t);
  if (isNaN(r))
    return "R$ 0,00";
  const n = r / 100, a = {
    style: "currency",
    currency: "BRL",
    maximumFractionDigits: 2
  };
  return new Intl.NumberFormat("pt-BR", a).format(n);
}
export {
  c as M,
  $ as g
};
